import type { FaireProductEntity } from "../../entity_types/product";

export const p_mwfzuymnbe: FaireProductEntity = {
  token: "p_mwfzuymnbe",
  type: "product",
  name: "Mahjong #1 Decoupage Glass Tray",
  brandToken: "b_bdd27564",
  brandName: "Ben's Garden",
  imageUrl:
    "https://cdn.faire.com/fastly/41f1340946623fc5bf720b5b4d1c91ba0550999584b6ddcf807da074e8b2748c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82dea610ad6a08f54d1fb0b2c56dd5a0ce2545301e837d005277b492fa22addd.jpeg",
    "https://cdn.faire.com/fastly/5e67bc37fa31a4e0bebd55222c27c2544e02228e49870400bfc85058a8887f8f.png",
    "https://cdn.faire.com/fastly/70891da05c325845262820ce53bd9d53b3631f1f276369df490920cd0cfb4801.png",
  ],
  priceDollars: 40,
  description:
    "Handcrafted in New York. Made to spark conversation.\n\nA single sparrow in flight: a whisper of springtime in Shanghai, inked in jewel tones and layered with memory. Inspired by the lyrical artistry of vintage mahjong tiles, this decoupage tray transforms an ancient game piece into a poetic object of desire.\n\nHandmade in our New York Studio using the time-honored French découpage technique, each glass tray tells a story of cross-cultural elegance and quiet ritual. It is signed individually by Ben—a gesture of craftsmanship and character—and backed in lush felt for a soft, satisfying finish.\n\nFood-safe and effortlessly cleanable, it is equal parts form and function: use it to cradle a morning espresso, corral your favorite pens, or hold court as a mini art piece on your bookshelf. However you use it, it never stays in the background.\n\nEach tray arrives with a folded note detailing the old-world découpage tradition, adding a literary touch to its already storied appeal.\n\nStyle#: DPI-6893",
  tags: [],
  msrpDollars: 72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:47.786Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
